<template>
  <div class="third looking-setting">
    <div class="third-formOne adhibition">
      <div class="formOne-btn">
        <div class="btn-left">
          <!-- <span class="left-back-icon" @click="goBack">
            <i class="el-icon-arrow-left"></i>
            <span class="left-back-title">返回</span>
          </span>
          <span class="left-back-shu">
            <span class="left-back-shu-content"></span>
          </span>-->
          <span class="left-back-content">系统通用配置</span>
          <!-- <span v-if="IDlist !== ''" class="left-back-content">编辑班级信息</span> -->
        </div>
        <div class="btn-right">
          <el-button @click="Reset()" class="btn-two" type="default">重置</el-button>
          <el-button class="btn-two" type="primary" v-el-disabel-repeat-click @click="save()">保存</el-button>
        </div>
      </div>
      <el-form ref="formList" :model="formList" :rules="rules" :show-message="false" label-width="100px" @validate="validateValue">
        <div class="formOne-forms">
          <div class="forms-one" style="margin-top: 57px;">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content palTel">展示信息</span>
              </div>
            </div>
            <div class="one-list myform">
              <el-form-item label="系统名称" prop="name">
                <el-input class="list-input myInput_config" :maxlength="16" v-model.trim="formList.name" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="校训" prop="description">
                <el-input class="list-input myInput_config" :maxlength="60" v-model.trim="formList.description" placeholder="请输入"></el-input>
              </el-form-item>
              <!-- <el-form-item label="系统logo" prop="advanceLogo">
                <el-upload
                  class="list-upload-img my-upload"
                  action="/api/blade-platform/platformapplyguiselogo/upload"
                  accept=".jpg, .jpeg, .png, .gif, .svg"
                  list-type="picture-card"
                  :file-list="adLandingBackImgList"
                  :on-success="getAdLandingBackImg"
                  :on-remove="removeAdLandingBackImg"
                  :on-error="hadleError"
                  :before-upload="beforeUpload"
                  :on-preview="handlePreview"
                >
                  <i class="el-icon-plus"></i>
                  <div class="list-upload-title" style="font-size:12px">点击上传</div>
                  <div slot="tip" class="list-upload-tip my-upload-footer" style="font-size:10px">10M以内，支持扩展名.png、.jpg、.jpeg、.gif、.svg，建议为632*112px的矩形图片</div>
                </el-upload>
              </el-form-item> -->
              <!-- <el-form-item label="校训" prop="description">
                <el-input
                  class="list-input myInput_config"
                  :maxlength="60"
                  v-model.trim="formList.description"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item label="是否开启预登陆页面" prop="description">
                <el-radio-group v-model="formList.isOpenPreLogin">
                  <el-radio :label="1">开启</el-radio>
                  <el-radio :label="0">关闭</el-radio>
                </el-radio-group>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="关闭后，将无法访问预登陆页面，将直接前往登录"
                  placement="top-start"
                >
                  <div style="display: inline-block;">
                    <tail-describe></tail-describe>
                  </div>
                </el-tooltip>
              </el-form-item>-->
            </div>
          </div>
          <div class="forms-one" style="margin-top: 17px;">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content palTel">管理员配置</span>
              </div>
            </div>
            <div class="one-list myform">
              <el-form-item label="业务总管理员" prop="cardManager">
                <el-button style="display:inline-block;margin-bottom: 10px; margin-left: 0 !important;" icon="el-icon-plus" @click="addFieldParams()" class="btn-two" type="default">新增</el-button>
                <span style="padding-left: 5px;font-size:12px;color: #aeaeb4;">业务总管理员可在一网通办中配置所有业务</span>
                <template>
                  <div class="one-list">
                    <div class="list-data-line" v-for="(item, index) in formList.cardManager" :key="index" style="margin-bottom:6px">
                      <div style="display: inline-block; vertical-align: top">
                        <el-form-item
                          label
                          :prop="'cardManager.' + index + '.id'"
                          :rules="{
                            required: true,
                            message: `请选择业务总管理员`,
                            trigger: 'change',
                          }"
                        >
                          <!-- <key-value-select
                            style="display:inline-block"
                            searchParam='userName'
                            :className="'list-input'"
                            v-model="item.adminId"
                            placeholder="请输入"
                            :autoSearch="true"
                            :openSearch="true"
                            :isNeedCash="false"
                            @SelectLabel="(value)=> {
                            item.adminName = value
                            }"
                            dictUrl="/api/blade-platform/platformapplyguiselogo/queryAdminInfo"
                          ></key-value-select>-->
                          <el-select
                            v-model="item.id"
                            filterable
                            remote
                            reserve-keyword
                            placeholder="请输入姓名/工号后选择"
                            :remote-method="
                            (query) => {
                                remoteMethod(query, index);
                            }
                            "
                            :loading="loading"
                            @change="change(item.id, index)"
                          >
                            <el-option v-for="item in item.list" :key="item.teacherId" :label="item.name + '(' + item.keyId + ')'" :value="item.teacherId"></el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                      <div style="width: 24px;display: inline-block;" class="list-addField-delete" @click="removeFieldParams(item)">
                        <el-button icon="el-icon-minus"></el-button>
                      </div>
                    </div>
                  </div>
                </template>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <preview-modal :previewModal="dialogVisible" :previewImageUrl="dialogImageUrl" @previewClose="closePreview"></preview-modal>
  </div>
</template>

<script>
import {
  platformapplyguiselogoDetail,
  platformapplyguiselogoUpdate,
} from "@/store/management/Myconfig"; //我的
export default {
  name: "formSeven",
  props: ["IDlist"],
  data() {
    return {
      loading: false,
      // color: '#FF4D4F',
      rules: {
        cardManager: [{ required: false,message: "请新增业务总管理员", trigger: "blur"}],
        name: [{ required: true, message: "请输入系统名称", trigger: "blur" }],
        description: [
          { required: true, message: "请输入校训", trigger: "blur" },
        ],
        websiteUrl: [
          { required: true, message: "请输入学校官网地址", trigger: "blur" },
          { type: "url", message: "请输入正确格式的网址" },
        ],
        // advanceBackground: [{ required: true, message: "请选择预登陆背景图" }],
        advanceLogo: [{ required: true, message: "请选择系统logo" }],
        // logo: [{ required: true, message: "请选择系统logo" }],
        advanceColor: [{ required: true, message: "请选择预登陆主题色" }],
        isOpenPreLogin: [{ required: true, message: "是否开启预登陆页面" }],
      },
      formList: {
        id: "",
        logo: "", //系统logo
        name: "", // 系统名称
        description: "", // 系统校训
        advanceBackground: "", // 预登陆背景图
        advanceLogo: "", // 预登陆logo
        websiteUrl: "", // 官网地址
        advanceColor: "", // 预登陆主题色
        webImConfig: 1, // web-im 启用配置
        isOpenPreLogin: 1,
        cardManager: [
          {
            list: [],
            name: "",
            id: "",
          },
        ],
      }, //数据
      fileList: [], //默认配置图
      dialogVisible: false,
      dialogImageUrl: "",
      adLandingBackImgList: [],
      adLandingLogoList: [],
      sysLogo: [],
      countNum: 1,
    };
  },
  created() {
    this.platformapplyguiselogoDetailFN();
  },
  methods: {
        // 输入搜索
    async remoteMethod(query, index) {
      this.loading = true;
      console.log(query, index);
      if (query !== "") {
        const arr = await this.$store.dispatch(
          "platformapplyguiselogoQueryAdminInfo",
          {
            userName: query,
          }
        );
        console.log(arr);
        this.formList.cardManager[index].list = arr.data.result.slice(0, 20);
        this.loading = false;
      } else {
        this.options = [];
      }
    },
        // 管理员不可重复
    change(val, i) {
      console.log(val, i);
      this.formList.cardManager.forEach((item, index) => {
        if (item.id == val && index != i) {
          this.$message.error("业务总管理员不可重复");
          this.formList.cardManager[i].id = "";
        }
      });
    },
    // 移除字段
    removeFieldParams(item) {
      this.formList.cardManager.splice(
        this.formList.cardManager.indexOf(item),
        1
      );
    },
    validateValue(prop, msgStatus, validateMessage) {
      if (!this.countNum && !msgStatus) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    // 新增字段
    addFieldParams() {
      let obj = {
        list: [],
        name: "",
        id: "",
      };
      this.$refs.formList.clearValidate('cardManager')
      if (this.formList.cardManager.length < 9) {
        this.formList.cardManager.push(obj);
        console.log(this.formList.cardManager);
      } else {
        this.$message.error("最多可添加9个业务管理员");
      }
    },
    toPreview() {
      // this.$router.push({
      //   name: 'previewAdvanceLanding'
      // });
      const strData = JSON.stringify(this.formList);
      sessionStorage.setItem("formValue", strData);
      const url =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "#/previewAdvanceLanding";
      window.open(url);
    },
    // 预登陆logo成功回调函数
    getAdLandingLogo(response) {
      console.log("data", response);
      this.formList.advanceLogo = response.result;
    },
    removeAdLandingLogo() {
      this.formList.advanceLogo = "";
      this.adLandingLogoList = [];
      // console.log(fileList)
    },
    removeSysLogo() {
      this.formList.logo = "";
      this.sysLogo = [];
      console.log(fileList);
    },
    // 系统logo成功回调函数
    getSysLogo(response) {
      this.formList.logo = response.result;
      console.log(fileList);
    },
    removeAdLandingBackImg() {
      this.formList.advanceLogo = "";
      this.adLandingBackImgList = [];
    },
    // 预登陆背景成功回调函数
    getAdLandingBackImg(response) {
      console.log("result", response);
      this.formList.advanceLogo = response.result;
      this.adLandingBackImgList = [{ url: response.result }];
    },
    handleExceed() {
      this.$message.error("一次只能上传一张图片");
    },
    save() {
      this.countNum = 0;
      this.$refs.formList.validate(async (valid) => {
        if (valid) {
            this.countNum = 1;
            await this.platformapplyguiselogoUpdateFN()
            this.platformapplyguiselogoUpdateFNTow()
        }
      })
    },
    platformapplyguiselogoUpdateFNTow() {
        //   const params = this.formList;
        let arr = [];
        this.formList.cardManager.forEach((item) => {
        arr.push(item.id);
        });
        const obj = {
        pageType: 1, //页面类型 1-全局信息配置 2-系统通用配置
        admins: arr.join(","), //业务管理员 多个以逗号分割
        description: this.formList.description, //学校校训 1
        };
        console.log(obj);
        platformapplyguiselogoUpdate(obj).then((res) => {
        const data = res.data;
        if (data.status === 1000) {
            // this.$message.success("操作成功");
            return true
        } else {
            this.countNum = 1;
            this.$message.error(data.msg);
        }
        });
    },
    //保存
    platformapplyguiselogoUpdateFN() {
      this.countNum = 0;
      this.$nextTick(() => {
        this.$refs.formList.validate((valid) => {
          if (valid) {
            try {
              //   const params = this.formList
              const obj = {
                pageType: 2, //页面类型 1-全局信息配置 2-系统通用配置
                name: this.formList.name, //业务管理员 多个以逗号分割
                logo: this.formList.advanceLogo, //学校校训 1
              };
              console.log(obj);
              platformapplyguiselogoUpdate(obj).then((res) => {
                const data = res.data;
                if (data.status === 1000) {
                  this.$message.success("操作成功");
                } else {
                  this.countNum = 1;
                  this.$message.error(data.msg);
                }
              });
            } catch (err) {
              this.countNum = 1;
              console.log(err);
            }
          } else {
            return false;
          }
        });
      });
      // console.log(this.formList)
      // if (this.formList.name.trim() == "") {
      //   this.$message.error("请填写系统名称")
      //   return
      // }
      // if (this.formList.logo == "") {
      //   this.$message.error("请上传系统logo")
      //   return
      // }
      // try {
      //   const params = this.formList
      //   platformapplyguiselogoUpdate(params).then(res => {
      //     const data = res.data
      //     if (data.status === 1000) {
      //       this.$message.success("操作成功")
      //     } else {
      //       this.$message.error(data.msg)
      //     }
      //   })
      // } catch (err) {
      //   console.log(err)
      // }
    },
    //重置
    Reset() {
      this.fileList = [];
      this.adLandingBackImgList = [];
      this.sysLogo = [];
      this.adLandingLogoList = [];
      this.platformapplyguiselogoDetailFN();
    },
    //获取数据
    platformapplyguiselogoDetailFN() {
      try {
        platformapplyguiselogoDetail().then((res) => {
          const data = res.data;
          if (data.status === 1000) {
            console.log("返回数据", data);
            // this.formList = data.result[0]
            // Object.assign(this.formList, data.result[0])
            this.formList.name = data.result[0].name;
            // 文档1.8.5删掉的logo传空
            // this.formList.advanceLogo = ''
            // this.formList.logo = ''
            // this.fileList.push({ url: this.formList.logo })
            this.formList.advanceLogo = data.result[0].logo;
            this.adLandingBackImgList = [{ url: data.result[0].logo }];
            this.formList.description = data.result[0].description;
            if (data.result[0].adminList) {
              let newArr = [];
              data.result[0].adminList.forEach((item, index) => {
                // this.remoteMethod(item, index);
                newArr.push({
                  list: [
                    {
                        teacherId: item.user_id,
                        name: item.user_name,
                        keyId: item.user_key_id
                    }
                  ],
                  name: "",
                  id: item.user_id,
                });
              });
              this.formList.cardManager = newArr;
            } else {
              this.formList.cardManager = [
                {
                  list: [],
                  name: "",
                  id: "",
                },
              ];
            }
            console.log(this.oldForm);
          } else {
            Object.assign(this.$data, this.$options.data());
            this.$message.error(data.msg);
          }
          console.log(this.formList);
        });
      } catch (err) {
        console.log(err);
      }
    },
    //上传之前
    beforeUpload(file) {
      console.log(file);
      const isJPG = [
        "image/png",
        "image/jpg",
        "image/jpeg",
        "image/svg+xml",
        "image/gif",
      ].indexOf(file.type);

      if (isJPG == -1) {
        this.$message.error("上传头像只能是png jpg jpeg gif svg图片格式!");
        return false;
      }

      const imgsize = file.size / 1024 / 1024 <= 10;
      if (!imgsize) {
        this.$message.error("上传图片最大10M, 请重新上传!");
        return false;
      }
    },
    //成功
    handleSuccess(file) {
      // console.log(file)
      this.formList.logo = file.result;
    },
    //点击
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //失败
    hadleError(err) {
      this.$message.error(err);
    },
    //移除
    handleRemove(file, fileList) {
      this.formList.logo = "";
      console.log("移除");
    },
    //关闭弹框
    closePreview() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss">
.looking-setting {
    .list-addField-delete {
    display: inline-block;
    height: 28px;
    line-height: 28px;
    text-align: left;
    .el-button {
        width: 16px;
        height: 16px;
        padding: 0;
        color: #ff4d4f;
        border: 1px solid #ff4d4f;
        vertical-align: middle;
    }
    }
  .phon-right {
    position: relative;
    // border:1px solid red;
    width: 40%;
    display: inline-block;
    // height:calc(100vh - 102px);
    height: 100%;
    border-left: 1px solid #dcdee2;
    img {
      // border: 1px solid red;
      width: 389px;
      height: 669px;
      position: absolute;
      left: 0;
      right: 0;
      margin: auto;
    }
  }
  .advance-theme {
    .el-button {
      margin-left: 0 !important;
    }
  }
  .myform {
    .el-form-item__label {
      padding-right: 10px;
    }
  }
  .myInput_config {
    width: 298px !important;
  }
  .palTel {
    font-size: 14px !important;
  }
  .my-upload {
    height: 115px;
    position: relative;
    .el-upload--picture-card {
      width: 80px !important;
      height: 80px !important;
      line-height: 80px !important;
      float: left;
      overflow: hidden;
    }
    .el-upload-list__item {
      width: 204px !important;
      height: 80px !important;
      margin-left: 14px !important;
    }
    .my-upload-footer {
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }
}
</style>
